import { useEffect, useState } from "react";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import BentoCategories from "@/components/BentoCategories";
import Featured from "@/components/Featured";
import FastFoodStrip from "@/components/FastFoodStrip";
import Craft from "@/components/Craft";
import api from "@/lib/api";

export default function Home() {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data)).catch(() => {});
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <BentoCategories categories={categories} products={products} />
      <Featured products={products} />
      <FastFoodStrip />
      <Craft />
    </main>
  );
}
